import { useQuery } from '@tanstack/react-query';
import { getAdAccounts } from './api';

// Resolve the kyck Account's linked Meta ad account currency + timezone on-pick
// (B2b.2). Shared by the Campaign (CBO) + Ad Set (ABO) budget surfaces; react-query
// dedupes the call by the ['metaAdAdAccounts', accountId] key.
export function useLinkedAdAccount(accountId: string): {
  currency: string | null;
  timezoneName: string | null;
  adAccountId: string | null; // the linked ad account's act_… id (for reference display)
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ['metaAdAdAccounts', accountId],
    queryFn: () => getAdAccounts(accountId),
    enabled: accountId.trim().length > 0,
  });
  const linked = q.data?.adAccounts.find((a) => a.isLinkedToKyckAccount);
  return {
    currency: linked?.currency ?? null,
    timezoneName: linked?.timezoneName ?? null,
    adAccountId: linked?.id ?? null,
    isLoading: q.isLoading && accountId.trim().length > 0,
  };
}
